import { VIDA_ENUM_ROUTES } from '../requestsService';
import type {
  EstadosCivisResponse,
  GrausEscolaridadeResponse,
  OrigensDadosResponse,
  TiposPapelPessoaResponse,
} from '../../types/vida/enum/enumType';

export class EnumService {
  private fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>;

  constructor(fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>) {
    this.fetch = fetch;
  }

  /**
   * Get Enum Types Person Role.
   * Endpoint: /v1/bff/cadp/dominios-enum/tipos-papel-pessoa
   */
  async getPersonRoleTypes(): Promise<TiposPapelPessoaResponse> {
    const url = VIDA_ENUM_ROUTES.GET_ENUM_TYPES_PERSON_ROLE;
    return this.fetch<TiposPapelPessoaResponse>(url, { method: 'GET' });
  }

  /**
   * Get Enum Data Sources.
   * Endpoint: /v1/bff/cadp/dominios-enum/origens-dados
   */
  async getDataSources(): Promise<OrigensDadosResponse> {
    const url = VIDA_ENUM_ROUTES.GET_ENUM_DATA_SOURCES;
    return this.fetch<OrigensDadosResponse>(url, { method: 'GET' });
  }

  /**
   * Get Enum Education Levels.
   * Endpoint: /v1/bff/cadp/dominios-enum/graus-escolaridade
   */
  async getEducationLevels(): Promise<GrausEscolaridadeResponse> {
    const url = VIDA_ENUM_ROUTES.GET_ENUM_EDUCATION_LEVEL;
    return this.fetch<GrausEscolaridadeResponse>(url, { method: 'GET' });
  }

  /**
   * Get Enum Civil Status.
   * Endpoint: /v1/bff/cadp/dominios-enum/estados-civis
   */
  async getCivilStatus(): Promise<EstadosCivisResponse> {
    const url = VIDA_ENUM_ROUTES.GET_ENUM_CIVIL_STATUS;
    return this.fetch<EstadosCivisResponse>(url, { method: 'GET' });
  }
}

